import { apiCallCenter } from '@/plugins/axios'
import { hostname } from '@/utils/hostname'


export default {
  geraRelatorioDetalhadoOperador(data, id) {
    return apiCallCenter().post(`/relatorios/operadores/detalhado/${id}?_method=GET`, data)
  },
  exportExcel(params) {
    let query = new URLSearchParams(params.dateTimeRange).toString();

    if(params.operadores.length == 0){
      query = `${query}&operadores[]=${params.operadores}`
    }else{
      params.operadores.forEach(operador => {
        query = `${query}&operadores[]=${operador}`
      })
    }
    if(params.centrosDeCusto.length == 0){
      query = `${query}&centrosDeCusto[]=${params.centrosDeCusto}`
    }else{
      params.centrosDeCusto.forEach(centrosDeCusto => {
        query = `${query}&centrosDeCusto[]=${centrosDeCusto}`
      })
    }
    if(params.numeroOrigem.length == 0){
      query = `${query}&numeroOrigem[]=${params.numeroOrigem}`
    }else{
      params.numeroOrigem.forEach(numeroOrigem => {
        query = `${query}&numeroOrigem[]=${numeroOrigem}`
      })
    }
    if(params.status.length == 0){
      query = `${query}&status[]=${params.status}`
    }else{
      params.status.forEach(status => {
        query = `${query}&status[]=${status}`
      })
    }
    if(params.tipos.length == 0){
      query = `${query}&tipos[]=${params.tipos}`
    }else{
      params.tipos.forEach(tipos => {
        query = `${query}&tipos[]=${tipos}`
      })
    }
    if(params.maiorQue != 0){
      query = `${query}&maiorQue=${params.maiorQue}`
    }else{
      query = `${query}&maiorQue=0`
    }
    const token = window.localStorage.getItem('pcm_access_token')
    query = `${query}&token=${token}`
    return `https://${hostname()}/backend/callcenter/relatorios/operadores/detalhado/export?${query}`
  },
}
